export default __webpack_public_path__ + "static/media/haunted_hayride_color.fa88234e.png";